/* eslint-disable jsx-a11y/role-supports-aria-props */
import ShopFnbFacilitySearchModeButton from '@/components/common/shop-fnb-facility/buttons/search-mode';
import { CATEGORY_TYPE_SEARCH_MODE } from '@/enums/category-type';
import { useOrientation } from '@/hooks';
import useBaseSize from '@/hooks/useBaseSize';
import { getHSize } from '@/utils/size';
import { TrackingService } from '@/services/analytics/TrackingService';
import { useCategoryTypeStore } from '@/stores';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

interface CategoryTypeSearchControlProps {
    currentMode: CATEGORY_TYPE_SEARCH_MODE;
    isVerticalFullscreen?: boolean;
}

const CategoryTypeSearchControl = ({ currentMode, isVerticalFullscreen = false }: CategoryTypeSearchControlProps) => {
    const { t } = useTranslation();
    const { isHorizontal } = useOrientation();
    const { baseHeight } = useBaseSize();
    const setCurrentMode = useCategoryTypeStore((state) => state.setCurrentMode);
    const updateCategoryTypeContents = useCategoryTypeStore((state) => state.updateCategoryTypeContents);
    const setSearchText = useCategoryTypeStore((state) => state.setSearchText);
    const resetFilters = useCategoryTypeStore((state) => state.resetFilters);

    const handleChangeMode = (mode: CATEGORY_TYPE_SEARCH_MODE) => {
        TrackingService.clearSearchKeyword();
        resetFilters();
        setCurrentMode(mode);
        updateCategoryTypeContents(mode);
    };

    return (
        <div
            className={clsx('flex w-full items-center justify-center', isVerticalFullscreen ? 'flex-row' : 'flex-col')}
            style={{ gap: isVerticalFullscreen ? getHSize(12, baseHeight) : isHorizontal ? getHSize(8, baseHeight) : getHSize(12, baseHeight) }}
            data-region-nav
        >
            <ShopFnbFacilitySearchModeButton
                tabIndex={6}
                fullWidth
                role="tab"
                type="button"
                aria-label={t('category_type.search.tts.control_buttons.search_by_text')}
                title={t('category_type.search.text.control_buttons.search_by_text')}
                onClick={() => {
                    setSearchText('');
                    handleChangeMode(CATEGORY_TYPE_SEARCH_MODE.SEARCH_BY_TEXT);
                }}
                aria-checked={currentMode === CATEGORY_TYPE_SEARCH_MODE.SEARCH_BY_TEXT}
                data-interactive
            />
            <ShopFnbFacilitySearchModeButton
                tabIndex={7}
                fullWidth
                role="tab"
                type="button"
                aria-label={t('category_type.search.tts.control_buttons.search_by_floor')}
                title={t('category_type.search.text.control_buttons.search_by_floor')}
                onClick={() => handleChangeMode(CATEGORY_TYPE_SEARCH_MODE.SEARCH_BY_FLOOR)}
                aria-checked={currentMode === CATEGORY_TYPE_SEARCH_MODE.SEARCH_BY_FLOOR}
                data-interactive
            />
            <ShopFnbFacilitySearchModeButton
                tabIndex={8}
                fullWidth
                role="tab"
                type="button"
                aria-label={t('category_type.search.tts.control_buttons.search_by_category')}
                title={t('category_type.search.text.control_buttons.search_by_category')}
                onClick={() => handleChangeMode(CATEGORY_TYPE_SEARCH_MODE.SEARCH_BY_CATEGORY)}
                aria-checked={currentMode === CATEGORY_TYPE_SEARCH_MODE.SEARCH_BY_CATEGORY}
                data-interactive
            />
        </div>
    );
};

export default CategoryTypeSearchControl;
